export default __webpack_public_path__ + "static/media/logo.c7fa4a48.svg";